import React from "react";
import "./style.css";
import { Helmet } from "react-helmet";
//import Trending from "components/TrendingNow/Trending";
import PresentationCard from "components/PresentationCard/PresentationCard";
// import { Timeline } from 'react-twitter-widgets'
//import { TwitterTimelineEmbed,TwitterFollowButton} from 'react-twitter-embed';
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Footer from "components/Footer/Footer";
import TitleSection from "components/TitleBar/TitleSection";
import SpotLightPk from 'components/spotlightedPK/spotlightedPK';
// import CommunityPKPlayer from 'components/CommunityPKPlayer/CommunityPKPlayer';
import Organizer from 'components/Organizers/Organizers';
import { current_unix_stamp, timeStampDiff, unixTimeStamp } from "utils/Helper";
// ,unixDateConversion,timeDiff,dateConvert, DaysDiff, HoursDiff, getKey, 
// import CategoryModal from "pages/LoginPage/RegisterForm/CategoryModal/CategoryModal";
import { user_Status } from "Api/Api";
// , user_API 
// import Help from "../../Assets/Qicon.png";
import Container from "react-bootstrap/Container";
// import Carousel from "react-bootstrap/Carousel";
// import Button from "../../components/Button/Button";
import axios from 'axios';
//import { events_list_api,search_Presentation_API,events_search_list_api, HeaderConfig, managed_contents, managed_contents_PechaKucha_Inc, myHeaders_Authorized, user_entity_uuid } from "Api/Api";
import { org_friendly_url, apiUrl, searchUrl, myHeaders_Auth_With_Cache_Control, myHeaders_With_Cache_Control, user_entity_uuid } from "Api/Api";
// search_Presentation_API,events_search_list_api, managed_contents, myHeaders_Authorized, 
import ActivityIndicator from "components/ActivityIndicator/ActivityIndicator";
import { withRouter } from "react-router-dom";
import { local_routes } from 'utils/Routes';
// import { NavLink } from "react-router-dom";
import home from 'Assets/home.svg';
import heroImg1 from 'Assets/hero-banner-adjusted/imge-1.jpg';
import heroImg2 from 'Assets/hero-banner-adjusted/imge-2.jpg';
import heroImg3 from 'Assets/hero-banner-adjusted/imge-3.jpg';
import heroImg4 from 'Assets/hero-banner-adjusted/imge-4.jpg';
import heroImg5 from 'Assets/hero-banner-adjusted/imge-5.jpg';
import heroImg6 from 'Assets/hero-banner-adjusted/imge-6.jpg';
import heroImg7 from 'Assets/hero-banner-adjusted/imge-7.jpg';
import heroImg8 from 'Assets/hero-banner-adjusted/imge-8.jpg';
import heroImg9 from 'Assets/hero-banner-adjusted/imge-9.jpg';
import heroImg10 from 'Assets/hero-banner-adjusted/imge-10.jpg';
// import rightArrow from 'Assets/arrow-right-circle.svg';
// import pechakuchaNight from 'Assets/logo-city.png';
// let modal_stat_key, modalStatus;
let randomColors = ['#00FDC3', '#6EAAFF', '#AE7BFF', '#FF626F', '#FFAB9C', "#00C294", "#FFF2A2", "#AE7BFF", "#FF626F", "#FFD266", "#6EAAFF", "#00FDC3"];
let carouselImage=[heroImg1,
heroImg2,
heroImg3,
heroImg4,
heroImg5,
heroImg6,
heroImg7,
heroImg8,
heroImg9,
heroImg10,];


class WorkspaceHomePage extends React.Component {
 
  constructor(props) {
    super(props);
    this.state = {
      community_event_presentation_array: [],
      community_event_info: {},
      org_data: {},
      spotlighted_pk_data: {},
      trending_pk_array: [],
      featured_pk_array: [],
      recent_presenter_array: [],
      spotlighted_pk_presenter_data: {},
      loading: true,
      likeLoader: false,
      labelLike: 'like',
      liked: false,
      applaudCount: 0,
    };
    
    this.workspace_base_url = "";
    if (org_friendly_url) {
      this.workspace_base_url = local_routes.workspace+"/"+org_friendly_url;
    }
  }

  componentDidUpdate (prevProps) {
    let { location: { pathname } } = this.props;

    if (prevProps.location.pathname === pathname) return;
    this.routeChanged();
  }

  routeChanged () {
      this.APICalls();
  }

  componentDidMount() {
      this.routeChanged();
  }

  //componentDidMount = async function () {
  APICalls = async function () {
    this.setState({
      loading: true
    });
    console.log("WorkspaceHomePage APICalls",org_friendly_url);
    let DifftimeStamp = timeStampDiff(300);
    let parsedUnixTime = unixTimeStamp(DifftimeStamp);

    let audience_params = {
      attributes: ['entity_uuid']
    };

    // API Calls starts here
    let [org_data_response,spotlighted_pk_data_response,trending_pk_data_response,recent_pks_data_response,user_liked_response,community_events_response,featured_pks_response] = await Promise.all([
      axios.get(`${apiUrl}organizations/${org_friendly_url}`),
      //axios.get(`${apiUrl}organizations/${org_friendly_url}/presentations?sort[spotlighted_time]=desc&limit=1`), // spotlighted
      axios.get(`${apiUrl}organizations/${org_friendly_url}/presentations?do_recursive=true&sort_obj=${encodeURIComponent('{"spotlighted_time":"desc"}')}&limit=1`), // spotlighted
      axios.get(`${searchUrl}presentationsearch?get_presenter=true&sort_by=view_count&search_start_time=${parsedUnixTime}&search_end_time=${current_unix_stamp}&limit=${3}`), // trending
      //axios.get(`${apiUrl}organizations/${org_friendly_url}/presentations?sort[created_time]=desc&limit=20`), // recent presentations so we can get recent presenters
      axios.get(`${apiUrl}organizations/${org_friendly_url}/presentations?do_recursive=true&sort_obj=${encodeURIComponent('{"created_time":"desc"}')}&limit=20`), // recent presentations so we can get recent presenters
      axios.get(`${apiUrl}users/${user_entity_uuid}/presentations.audience`, { params: audience_params }), // just to see if user has already liked this spotlighted presentation
      axios.get(`${searchUrl}eventsearch?event_type=community_pk`),
      axios.get(`${apiUrl}organizations/${org_friendly_url}/presentations?do_recursive=true&filter_obj=${encodeURIComponent('{"featured_time":{"gte":1}}')}&sort_obj=${encodeURIComponent('{"featured_time":"desc"}')}&limit=60`), // recent presentations so we can get recent presenters
    ]);
    
    let community_event_info = {};
    let community_event_presentation_array = [];
    let community_events = community_events_response.data.search_query_results.map((data) => data.entity_info);
    if (community_events.length > 0) {
      // get presentations for first one
      community_event_info = community_events[0];
      let community_event_presentation_response = await axios.get(`${apiUrl}events/${community_event_info.entity_uuid}/presentations?sort_obj=${encodeURIComponent('{"order_integer":"asc"}')}&filter_obj=${encodeURIComponent('{"order_integer":{"gte":1}}')}`);
      community_event_presentation_array = community_event_presentation_response.data;
    }
    
    
    // massage spotlighted pk data
    let spotlighted_pk_data = {};
    if (spotlighted_pk_data_response.data.length > 0) {
      spotlighted_pk_data = spotlighted_pk_data_response.data[0];
      // in the past, we did not remove old spotlighted pks, we just added new ones with newer times.
      //  to get 'None' to work here, see if the xref spotlighted PK matches the one in the org. if no match, don't show.
      if (!org_data_response.data.spotlighted_presentations_uuid || spotlighted_pk_data.entity_uuid !== org_data_response.data.spotlighted_presentations_uuid) {
        spotlighted_pk_data = {};
      }
    }
    if (spotlighted_pk_data.image_url && spotlighted_pk_data.pad_color) {
      // adjust poster_url for presentation
      let url = spotlighted_pk_data.image_url;
      let array = url.split("/");
      spotlighted_pk_data.image_url = `${array[0]}/${array[1]}/${array[2]}/${array[3]}/${array[4]}/pad${spotlighted_pk_data.pad_color}_1280x720/${array[5]}`;
    }
    
    // massage trending pk data
    let search_query_results = trending_pk_data_response.data && trending_pk_data_response.data.search_query_results ? trending_pk_data_response.data.search_query_results : [];
    let trending_pk_array = search_query_results.map((data) => data.entity_info);
    
    
    // get recent presenters from recent presentations
    let recent_presenter_array = [];
    for (let recent_pk_data of recent_pks_data_response.data) {
      if (recent_pk_data.users) {
        for (let pk_user_data of recent_pk_data.users) {
          if (pk_user_data.xref_data && pk_user_data.xref_data.presenter_integer) {
            recent_presenter_array.push(pk_user_data);
          }
        }
      }
    }
    // filter out dupes
    recent_presenter_array = recent_presenter_array.filter((ele, ind) => ind === recent_presenter_array.findIndex(elem => elem.entity_uuid === ele.entity_uuid));
    console.log("WorkspaceHomePage recent_presenter_array",recent_presenter_array);
    // get presenter data for spotlighted PK
    let spotlighted_pk_presenter_data = {};
    if (spotlighted_pk_data.users) {
      for (let tmp_user_data of spotlighted_pk_data.users) {
        if (tmp_user_data.xref_data && tmp_user_data.xref_data.presenter_integer) {
          if (tmp_user_data.firstname && tmp_user_data.lastname) {
            tmp_user_data.full_name = tmp_user_data.firstname + ' ' + tmp_user_data.lastname;
          } else if (tmp_user_data.lastname) {
            tmp_user_data.full_name = tmp_user_data.lastname;
          } else if (tmp_user_data.firstname) {
            tmp_user_data.full_name = tmp_user_data.firstname;
          } else {
            tmp_user_data.full_name = 'Unknown';
          }
          spotlighted_pk_presenter_data = tmp_user_data;
          break;
        }
      }
    }

    let labelLike = 'like';
    if (user_liked_response.data) {
      for (let element of user_liked_response.data) {
        if (element.entity_uuid === spotlighted_pk_data.entity_uuid) {
          if (element.xref_data && element.xref_data.applauded_time && element.xref_data.applauded_time > 0) {
            labelLike = 'unlike';
            break;
          }
        }
      }
    }
    
    this.setState({
      community_event_info,
      community_event_presentation_array,
      org_data: org_data_response.data,
      spotlighted_pk_data,
      trending_pk_array,
      featured_pk_array: featured_pks_response.data,
      recent_presenter_array,
      spotlighted_pk_presenter_data,
      labelLike,
      loading: false
    });
    
  }

  // Like And Unlike Method
  handleClickLike = async () => {
    const { labelLike } = this.state;
    if (user_Status === 1) {
      // Applaud Count API starts
      this.setState({ likeLoader: true });
      let decrement_flag = "";
      let new_label = 'unlike';
      if (labelLike === 'unlike') {
        decrement_flag = "&decrement=true";
        new_label = 'like';
      }
      let response = await axios.post(`${apiUrl}presentations/${this.state.spotlighted_pk_data.entity_uuid}/incrementCount?count_type=applaud${decrement_flag}`, {});

      if (response.data.message === "count not incremented - user has already done this action") {
        this.setState({ likeLoader: false });
        return null;
      }
      this.setState({ likeCount: response.data.new_count, labelLike: new_label, likeLoader: false });

      let audience_params = {
        attributes: ['entity_uuid']
      };

      // now bust cache
      axios.all([
        //axios.get(`${apiUrl}organizations/${org_friendly_url}/presentations?sort[spotlighted_time]=desc&limit=1`, myHeaders_With_Cache_Control),
        axios.get(`${apiUrl}organizations/${org_friendly_url}/presentations?do_recursive=true&sort_obj=${encodeURIComponent('{"spotlighted_time":"desc"}')}&limit=1`, myHeaders_With_Cache_Control),
        axios.get(`${apiUrl}users/${user_entity_uuid}/presentations.audience`, { params: audience_params, ...myHeaders_Auth_With_Cache_Control })
      ]);
    }
  }


  render() {
    // const guestHomeHead1 = carouselImage.map(item=>{
    //   backgroundImage: `url(${item.image_url})`
    // })
    /*
    const {nearbyEventData,noUserPresentations, carousalArr, cityStaticArr, topCategoryBasedPresentations, managedContentsHtmlSectionOne, managedContentsHtmlSectionTwo, managedContentsHtmlSectionThree, userFavCatPresentation, noUserFeaturedCatInc, featuredPkInc } = this.state;
    const guestHomeHead = nearbyEventData !== null ?    
    { backgroundImage: `url(${nearbyEventData.image_url})`, }
    :
    { backgroundImage: `url(${managedContentsHtmlSectionOne.image_url})`, };
    const spaceStyles = { marginLeft: 0, marginRight: 0 };

    let trending_presentations = userFavCatPresentation.concat(noUserPresentations);
    if (trending_presentations.length > 3) {
      trending_presentations.length = 3;
    }
    */
    
    if (this.state.loading === true) {
      return (
        <ActivityIndicator theme="spinner" />
      );
    }
    
    //console.log("WorkspaceHomePage state",this.state);
    
    let featured_or_trending = 'Trending';
    if (this.state.featured_pk_array.length > 0) {
      featured_or_trending = 'Featured';
    }
    
    return (
      <React.Fragment>
        <Helmet defer={false}>
          <title>Pecha Kucha 20x20: Discover Pecha Kucha presentations, stories, ideas, examples, and videos that will inspire</title>
        </Helmet>
        <div className="">
          <div className="container">
          {/*
          { (this.state.community_event_info.entity_uuid && this.state.community_event_presentation_array.length > 0) &&
            <div style={{ paddingBottom: "20px" }}>
              <CommunityPKPlayer
                workspace_base_url={this.workspace_base_url}
                presentation_array={this.state.community_event_presentation_array}
                event_info={this.state.community_event_info}
              >
              </CommunityPKPlayer>
            </div>
          }
          */}
          
          {
            this.state.spotlighted_pk_data.presentation_video_url &&
            <div style={{ paddingBottom: "10px" }}>
            <SpotLightPk
              city_or_channel_name={this.state.org_data.entity_name}
              presentation_data={this.state.spotlighted_pk_data}
              entity_name={this.state.spotlighted_pk_data.entity_name}
              avatar_image_url={this.state.spotlighted_pk_presenter_data.avatar_image_url}
              firstName={this.state.spotlighted_pk_presenter_data.firstname}
              lastName={this.state.spotlighted_pk_presenter_data.lastname}
              designation={this.state.spotlighted_pk_data['description']}
              full_name={this.state.spotlighted_pk_presenter_data.full_name}
              presenter_friendly_url={this.state.spotlighted_pk_presenter_data.friendly_url}
              friendly_url={this.state.spotlighted_pk_data.friendly_url}
              // eslint-disable-next-line
              designation={this.state.spotlighted_pk_presenter_data['description']}
              description={this.state.spotlighted_pk_data['description']}
              mailTo="mailto:support@pechakucha.org"
              textReport=""
              iconName="fa fa-flag"
              iconNameLike="fa fa-heart"
              noOfLikes={this.state.likeCount}
              handleClick={this.handleClickLike}
              likeLabel={this.state.labelLike}
              likeLoader={this.state.likeLoader}
              workspace_base_url={this.workspace_base_url}
            />
            </div>
          }
          

          {this.state.trending_pk_array.length >= 1 &&
            <div style={{ paddingTop: "10px" }} className="marbot10">
              <Container>
                <TitleSection
                  title={`${featured_or_trending} ${this.state.org_data.entity_name} Presentations`}
                  seeAll={false}
                  //Title_link='/'
                />
                  <Row>
                    {this.state.featured_pk_array.length > 0 ?
                      <React.Fragment>
                      {this.state.featured_pk_array.map(item => (
                        <Col key={item.entity_uuid} lg={4} sm={12} md={6}>
                          <PresentationCard
                              key={item.entity_uuid}
                              presentation_info={item}
                          />                      
                        </Col>
                      ))}
                      </React.Fragment>
                    :
                      <React.Fragment>
                      {this.state.trending_pk_array.map(item => (
                        <Col key={item.entity_uuid} lg={4} sm={12} md={6}>
                          <PresentationCard
                              key={item.entity_uuid}
                              presentation_info={item}
                          />                      
                        </Col>
                      ))}
                      </React.Fragment>
                    }
                  </Row>
              </Container>
            </div>
          }
          
          
          {
            this.state.recent_presenter_array.length > 0 &&
            <div className="container">
              <div className=" presentation-section speakers-section">
                <TitleSection title={`Recent ${this.state.org_data.entity_name} Presenters`} />
                <div>
                  <Row>
                    {
                      this.state.recent_presenter_array.map((item, index) =>
                        <Col key={index} sm={12} md={6} lg={6}>
                          <Organizer
                            show_Icon={false}
                            Organizer_firstname={item.firstname}
                            Organizer_lastname={item.lastname}
                            Organizer_text={item.description}
                            profile_pic={item.avatar_image_url}
                            Organizer_link={
                              (item.friendly_url !== undefined && item.friendly_url !== null) ? `${this.workspace_base_url}${local_routes.users}/${item.friendly_url}`
                              : null
                            }
                          />
                        </Col>
                      )}
                  </Row>
                </div>
              </div>
            </div>
          }
          
          
          </div>
          <Footer
            homeImg={home}
          />
        </div>
      </React.Fragment>
      );
    }

}

export default withRouter(WorkspaceHomePage);
